const messages = {
  projectsDescription: "Know our latest projects",
  ourProjects: "Our Projects",
  ourClients: "Our Clients",
  btnShow: "Show"
};
export default messages;
